export const timestampFormat = 'EEE dd MMM yyyy HH:mm:ss';
